export const vertexShader = `

varying vec3 vWorldNormal;
varying vec3 vNormal;

uniform float time;

void main() {

  vNormal = ( normalMatrix * normal ).xyz;

  vWorldNormal = (modelMatrix * vec4( normal, 0.0) ).xyz;

  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

}`;

export default vertexShader;
